/*
 * Product page sliders: the evidence before/after card and the ingredient row.
 *
 *   <div data-qp-slider data-qp-slider-ms="500">
 *     <div data-qp-slider-track>  items...  </div>   a native scroll-snap row
 *     <button data-qp-slider-prev>   <button data-qp-slider-next>
 *     <span data-qp-slider-count>        optional "1 / 2"
 *     <span data-qp-slider-thumb>        optional progress thumb inside a bar
 *   </div>
 *
 * Touch and trackpads scroll the row natively and it snaps to each item. A
 * mouse can drag it. The arrows ease it along one item at a time, the way
 * GemPages' sliders moved (its CSS used "ease"; the ingredients ran 0.45s,
 * the before/after about 0.5s). The count and the progress thumb follow the
 * scroll position.
 *
 * Included by more than one section, so it guards against running twice and
 * picks up sliders again when the theme editor reloads a section.
 */
(function () {
  if (window.qpSlider) return;
  window.qpSlider = true;

  // CSS "ease", cubic-bezier(0.25, 0.1, 0.25, 1).
  function bezier(x1, y1, x2, y2) {
    function a(p1, p2) { return 1 - 3 * p2 + 3 * p1; }
    function b(p1, p2) { return 3 * p2 - 6 * p1; }
    function c(p1) { return 3 * p1; }
    function at(t, p1, p2) { return ((a(p1, p2) * t + b(p1, p2)) * t + c(p1)) * t; }
    function slope(t, p1, p2) { return 3 * a(p1, p2) * t * t + 2 * b(p1, p2) * t + c(p1); }
    return function (x) {
      if (x <= 0) return 0;
      if (x >= 1) return 1;
      var t = x;
      for (var i = 0; i < 8; i++) {
        var s = slope(t, x1, x2);
        if (!s) break;
        t -= (at(t, x1, x2) - x) / s;
      }
      return at(t, y1, y2);
    };
  }
  var ease = bezier(0.25, 0.1, 0.25, 1);
  var clamp = function (n, lo, hi) { return Math.max(lo, Math.min(hi, n)); };
  var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  // Eases a scroller to a position with snapping paused (.is-moving) so the
  // browser can't pull it elsewhere mid-way.
  function glide(el, to, ms, done) {
    if (el.qpGlide) cancelAnimationFrame(el.qpGlide);
    var from = el.scrollLeft;
    var dist = to - from;
    var start = null;
    el.classList.add('is-moving');
    function end() {
      el.qpGlide = null;
      el.scrollLeft = to;
      el.classList.remove('is-moving');
      if (done) done();
    }
    if (Math.abs(dist) < 1 || (reduceMotion && reduceMotion.matches)) {
      end();
      return;
    }
    el.qpGlide = requestAnimationFrame(function frame(ts) {
      if (start === null) start = ts;
      var p = Math.min(1, (ts - start) / ms);
      el.scrollLeft = from + dist * ease(p);
      if (p < 1) {
        el.qpGlide = requestAnimationFrame(frame);
      } else {
        end();
      }
    });
  }

  function init(root) {
    if (root.qpSliderReady) return;
    var track = root.querySelector('[data-qp-slider-track]');
    if (!track) return;
    root.qpSliderReady = true;

    var items = Array.prototype.slice.call(track.children);
    var prev = root.querySelector('[data-qp-slider-prev]');
    var next = root.querySelector('[data-qp-slider-next]');
    var count = root.querySelector('[data-qp-slider-count]');
    var thumb = root.querySelector('[data-qp-slider-thumb]');
    var ms = parseInt(root.getAttribute('data-qp-slider-ms') || '500', 10);
    var drag = null;

    function step() {
      return items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : track.clientWidth;
    }
    function maxLeft() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }
    function current() {
      return clamp(Math.round(track.scrollLeft / step()), 0, items.length - 1);
    }

    function update() {
      var left = track.scrollLeft;
      var max = maxLeft();
      if (prev) prev.disabled = left <= 1;
      if (next) next.disabled = left >= max - 1;
      if (count) {
        var i = left >= max - 1 ? items.length - 1 : current();
        count.innerHTML = '<b>' + (i + 1) + '</b> / ' + items.length;
      }
      if (thumb) {
        // As wide as the share of the row in view, and as far along as the
        // row has scrolled, like GemPages' bar.
        var share = track.clientWidth / track.scrollWidth;
        thumb.style.width = (Math.min(1, share) * 100) + '%';
        var along = max > 0 ? left / max : 0;
        thumb.style.transform = 'translateX(' + (along * (1 / share - 1) * 100) + '%)';
      }
    }

    function goTo(i) {
      i = clamp(i, 0, items.length - 1);
      glide(track, Math.min(items[i].offsetLeft - items[0].offsetLeft, maxLeft()), ms, update);
    }

    if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
    if (next) next.addEventListener('click', function () { goTo(current() + 1); });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        update();
      });
    }, { passive: true });
    window.addEventListener('resize', update);

    // Mouse drag, one item per flick; a plain click still reaches links and
    // buttons inside the items.
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (track.qpGlide) {
        cancelAnimationFrame(track.qpGlide);
        track.qpGlide = null;
      }
      drag = { x: e.clientX, left: track.scrollLeft, from: current(), moved: false };
    });
    track.addEventListener('pointermove', function (e) {
      if (!drag) return;
      if (!(e.buttons & 1)) {
        release(e);
        return;
      }
      var dx = e.clientX - drag.x;
      if (!drag.moved) {
        if (Math.abs(dx) < 5) return;
        drag.moved = true;
        track.classList.add('is-dragging');
        try { track.setPointerCapture(e.pointerId); } catch (err) {}
      }
      track.scrollLeft = drag.left - dx;
    });
    function release(e) {
      if (!drag) return;
      var d = drag;
      drag = null;
      if (!d.moved) {
        if (track.classList.contains('is-moving')) goTo(current());
        return;
      }
      var dx = e.clientX - d.x;
      var w = step();
      var far = Math.round(-dx / w);
      var target = d.from;
      if (far !== 0) {
        target = d.from + far;
      } else if (dx < -Math.min(50, w * 0.1)) {
        target = d.from + 1;
      } else if (dx > Math.min(50, w * 0.1)) {
        target = d.from - 1;
      }
      goTo(target);
      track.classList.remove('is-dragging');
      // Swallow the click that ends a drag, so a card's + doesn't open. The
      // guard lapses at once, so it can never eat a later, real click.
      var swallow = function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
      };
      track.addEventListener('click', swallow, true);
      setTimeout(function () { track.removeEventListener('click', swallow, true); }, 60);
    }
    track.addEventListener('pointerup', release);
    track.addEventListener('pointercancel', release);

    update();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(update);
  }

  function scan(scope) {
    scope.querySelectorAll('[data-qp-slider]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else {
    scan(document);
  }
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
